import { render } from "./CreateNewItems.vue?vue&type=template&id=09bbfcef"
import script from "./CreateNewItems.vue?vue&type=script&lang=js"
export * from "./CreateNewItems.vue?vue&type=script&lang=js"
script.render = render

export default script